import React, { forwardRef, useImperativeHandle, useState } from 'react'
import useQA from 'hooks/useQA'
import styles from './SearchInput.module.scss'
import SearchIcon from 'svg/search-icon.svg'
import classNames from 'classnames'
import ClearIcon from 'svg/SA/close-x-small.svg'

export type SearchInputApi = {
  query: string
}

type SearchInputProps = {
  onSearch?: (query: string) => void
  onChange?: (query: string) => void
  placeholder?: string
  customStyles?: string
}

const SearchInput = forwardRef<SearchInputApi, SearchInputProps>(
  ({ onSearch, onChange, placeholder, customStyles = '' }, ref) => {
    const [query, setQuery] = useState<string>('')
    const { testId } = useQA()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setQuery(event.target.value)
      onChange?.(event.target.value)
    }

    const handleSearch = () => {
      onSearch?.(query)
    }

    const handleClearInput = () => {
      setQuery('')
      onChange?.('')
      onSearch?.('')
    }

    useImperativeHandle(ref, () => ({
      query,
    }))

    return (
      <div
        className={classNames(styles.searchField, {
          [customStyles]: customStyles !== '',
        })}
        {...testId('search-input')}
      >
        <div className={styles.searchIconBox} onClick={handleSearch}>
          <SearchIcon />
        </div>
        <input type='text' value={query} onChange={handleChange} placeholder={placeholder} />
        {query !== '' && (
          <div className={styles.clearInputBox} onClick={handleClearInput}>
            <ClearIcon />
          </div>
        )}
      </div>
    )
  }
)

export default SearchInput
